/**
 * Versão da aplicação — única fonte de verdade no frontend.
 * Bumpar JUNTO com package.json raiz, functions/package.json e
 * docs/correcao_de_bugs-updates.md (regra de release herdada do INCHAT).
 */
export const APP_VERSION = '1.140.2';
